import React, { useContext, useEffect, useReducer, useState } from "react";
import axios from "axios";
import JIcon from "../../components/UI/Icon/JIcon";
import scrollToComponent from "react-scroll-to-component";
import classes from "./MenuIdeas.module.scss";
// import HTMLEllipsis from 'react-lines-ellipsis/lib/html';
import MenuIdeaComponent from "../../components/Home/MenuIdea/MenuIdeaComponent";
import MenuIdeasTitle from "../../components/UI/MenuIdeaTitle/MenuIdeasTitle";
import { HomeBreadcrumb } from "../../components/UI/HomeButton";
import Pagination from "../../components/UI/Pagination/Pagination";
import { Helmet } from "react-helmet";
import CountSortingContainer from "../../components/UI/CountSortingContainer/CountSortingContainer";
import { isMobileOnly, isTablet } from "react-device-detect";
import { gaTracker } from "../../helper/Helper";
import ReactGa from "react-ga";
import {
  FETCH_INIT_DATA,
  IS_ERROR,
  IS_LOADING,
  PAGE_SETTINGS,
} from "../../constants";
import { LoadingSimple } from "../../components/UI/LoadingBar";
import update from "immutability-helper";
import { utilScrollUp } from "../../utils/Utils";
import { FormattedMessage } from "react-intl";
import { Context } from "../../context/Wrapper";

//add by hendra on 13 oct 2020 06.00 pm
const [paramCategory, paramAction] = ["Search", "Search Menu Ideas"];

const initialState = {
  latest_menu_ideas: [],
  product_categories: [],
  menu_ideas: [],
  isLoading: false,
  isLoadOnSearch: false,
  defaultOps: 0,
  postPerPage: isMobileOnly || isTablet ? 12 : 9,
  currentPage: 1,

  hasError: false,

  do_search: false,
  keywords: "",
};

const reducer = (state, action) => {
  switch (action.type) {
    case FETCH_INIT_DATA:
      return {
        ...state,
        latest_menu_ideas: action.latestMenuIdeas,
        product_categories: action.productCategories,
        menu_ideas: action.menuIdeas,

        defaultOps: 0,
        currentPage: 1,
        isLoading: action.isLoading,
        keywords: "",
      };
    case IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case IS_ERROR:
      return {
        ...state,
        hasError: action.payload,
      };
    case PAGE_SETTINGS:
      return {
        ...state,
        currentPage: action.currentPage,
      };
    case "FETCH_WITH_FILTER":
      return {
        ...state,
        menu_ideas: action.payload,
        currentPage: 1,
        defaultOps: 0,
        isLoadOnSearch: action.isLoadOnSearch,
      };
    case "ON_CHECK_FILTER":
      return {
        ...state,
        product_categories: action.payload,
      };
    case "SORTING_MENU":
      return {
        ...state,
        menu_ideas: action.payload,
        defaultOps: action.defaultOps,
      };

    case "ON_TYPE_KEYWORD":
      return {
        ...state,
        keywords: action.payload,
        // , keywords: ''
      };
    default:
      return state;
  }
};

const MenuIdeasPageHook = (props) => {
  const context = useContext(Context);

  const [options] = useState([
    { displayId: "-Pilih-", displayValue: "-Choose Sorting-", value: 0 },
    { displayId: "Nama (A-z)", displayValue: "Name (A-z)", value: 1 },
    { displayId: "Nama (Z-a)", displayValue: "Name (Z-a)", value: 2 },
    { displayId: "Terbaru", displayValue: "New Menu Ideas", value: 3 },
  ]);

  const [initEffect, setInitEffect] = useState(null);
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    //=================================================
    // console.log('useEffect 1');
    //=================================================
    ReactGa.pageview(
      window.location.origin.toString() + props.location.pathname
    );
    const loadDocumentTitle = () => {
      document.title = "Menu Ideas Japfa Food";
    };
    window.scrollTo(0, 0);

    const ourRequest = axios.CancelToken.source();
    const fetchData = async () => {
      // dispatch({type: IS_LOADING, payload: true})
      const header = {headers: {language: context.locale}};
      const latest_menu_ideas = await axios.get("latest_menu_ideas", header, {
        cancelToken: ourRequest.token,
      });
      const product_categories = await axios.get("product_categories", header, {
        cancelToken: ourRequest.token,
      });
      const temp_product_categories =
        product_categories.data &&
        product_categories.data.product_categories.map((x) => {
          return { ...x, is_checked: false };
        });
      const menu_ideas = await axios.get("menu_ideas", header, {
        cancelToken: ourRequest.token,
      });
      dispatch({
        type: FETCH_INIT_DATA,
        latestMenuIdeas: latest_menu_ideas.data.menu_ideas,
        productCategories: temp_product_categories,
        menuIdeas: menu_ideas.data.menu_ideas,
        isLoading: false,
      });
    };
    try {
      loadDocumentTitle();
      fetchData();
      // dispatch({type: 'ON_TYPE_KEYWORD', payload: ''})
      dispatch({ type: "SORTING_MENU", payload: [], defaultOps: 0 });
      setInitEffect(null);
    } catch (e) {}
    //hooks cleanup
    return () => {
      ourRequest.cancel(); // <-- 3rd step
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.location.pathname, props.history, context.locale]);

  useEffect(() => {
    //=================================================
    // console.log('useEffect 2');
    //=================================================

    const ourRequest = axios.CancelToken.source(); // <-- 1st step
    const fetchWithFilter = async () => {
      const header = {headers: {language: context.locale}};
      const data = new FormData();
      state.product_categories
        .filter((x) => x.is_checked === true)
        .map((x) => {
          data.append("product_category_cd[]", x.product_category_cd);
          return null;
        });
      data.append("keyword", state.keywords.length < 1 ? "" : state.keywords);

      const get_products = await axios.post("menu_idea_filter", data, header);

      // setProducts(get_products.data.products)
      dispatch({
        type: "FETCH_WITH_FILTER",
        payload:
          get_products.data.menu_ideas.length > 0
            ? get_products.data.menu_ideas
            : [{ id: null }],
        // , isNodata: get_products.data.products === undefined
      });
    };
    try {
      /*---------------------------------------------------------------------------------------
              @desc:
            * ---------------------------------------------------------------------------------------*/
      if (initEffect !== null) {
        // console.log('setInitEffect()');
        // eslint-disable-next-line react-hooks/exhaustive-deps
        fetchWithFilter();
      } else {
        return;
      }
    } catch (e) {
      // setIsError(true)
      setInitEffect(null);
    }

    //hooks cleanup
    return () => {
      ourRequest.cancel(); // <-- 3rd step
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.product_categories, initEffect]);

  const onChangeKeywordHandler = (event) => {
    if (
      event.target.value.trim().length > 0 &&
      event.target.value.trim().length < 3
    ) {
      dispatch({ type: IS_ERROR, payload: true });
    } else if (event.target.value.trim().length === 0) {
      dispatch({ type: IS_ERROR, payload: false });
    } else if (event.target.value.length > 2) {
      dispatch({ type: IS_ERROR, payload: false });
    }
    dispatch({ type: "ON_TYPE_KEYWORD", payload: event.target.value });
    setInitEffect(null);
  };

  const doSearchProductsButton = () => {
    if (state.keywords.length < 3) {
      dispatch({ type: IS_ERROR, payload: true });
    } else {
      dispatch({ type: IS_ERROR, payload: false });
      const keyword = state.keywords;
      gaTracker(paramCategory, paramAction, keyword.toLowerCase());
      dispatch({ type: "ON_TYPE_KEYWORD", payload: keyword });
      setInitEffect(true);
    }
  };

  const gotoDetailMenuIdea = (slug, paramTitle) => {
    //add by hendra on 19 oct 2020
    localStorage.setItem("menu_ideas:selected_detail", paramTitle);
    props.history.push("/menu-ideas-detail/" + slug);
  };

  const onFocusHandler = () => {
    setInitEffect(null);
  };

  const onEnterKeyHandler = (event) => {
    if (!state.hasError && event.key === "Enter") {
      const keyword = event.target.value;
      gaTracker(paramCategory, paramAction, keyword.toLowerCase());
      dispatch({ type: "ON_TYPE_KEYWORD", payload: keyword });
      setInitEffect(true);
    }
  };

  const onFilterHandler = (event) => {
    const subCategoryIndex = state.product_categories.findIndex(
      (x) => x.slug === event.target.value
    );
    const newData = update(state.product_categories[subCategoryIndex], {
      is_checked: { $set: event.target.checked },
    });
    const subCategoriesWithUpdated = [...state.product_categories];
    subCategoriesWithUpdated[subCategoryIndex] = newData;
    dispatch({ type: "ON_CHECK_FILTER", payload: subCategoriesWithUpdated });
    setInitEffect(true);
  };

  const otherProductCategory = state.product_categories.map((item, index) => {
    return (
      <li key={`${item.id}${index}`} className={classes.Filter_row_items}>
        <input
          type="checkbox"
          checked={item.is_checked}
          value={item.slug}
          id={item.product_category_cd}
          onChange={(e) => onFilterHandler(e)}
        />
        <label htmlFor={item.product_category_cd}>{item.name}</label>
      </li>
    );
  });

  const onSortHandler = (event) => {
    const value = event.target.value;
    switch (+value) {
      case 1:
        dispatch({
          type: "SORTING_MENU",
          payload: state.menu_ideas.sort(
            (a, b) => +(a.title > b.title) || -(a.title < b.title)
          ),
          defaultOps: value,
        });
        break;
      case 2:
        dispatch({
          type: "SORTING_MENU",
          payload: state.menu_ideas.sort(
            (a, b) => +(a.title < b.title) || -(a.title > b.title)
          ),
          defaultOps: value,
        });
        break;
      case 3:
        dispatch({
          type: "SORTING_MENU",
          payload: state.menu_ideas.sort(
            (a, b) =>
              +(a.created_on < b.created_on) || -(a.created_on > b.created_on)
          ),
          defaultOps: value,
        });
        break;
      case 0:
        dispatch({
          type: "SORTING_MENU",
          payload: state.menu_ideas.sort(
            (a, b) =>
              +(a.menu_idea_cd < b.menu_idea_cd) ||
              -(a.menu_idea_cd > b.menu_idea_cd)
          ),
          defaultOps: value,
        });
        break;
      default:
        return state;
    }
  };

  let pagination;
  // --------------------------------------------------
  const indexOfLastData = state.currentPage * state.postPerPage;
  const indexOfFirstData = indexOfLastData - state.postPerPage;
  const currentData =
    state.menu_ideas !== undefined
      ? state.menu_ideas.slice(indexOfFirstData, indexOfLastData)
      : [];
  const paginate = (pageNumber) => {
    dispatch({ type: PAGE_SETTINGS, currentPage: pageNumber });
    utilScrollUp();
  };
  const paginateNext = () => {
    dispatch({ type: PAGE_SETTINGS, currentPage: state.currentPage + 1 });
    utilScrollUp();
  };
  const paginatePrev = () => {
    dispatch({ type: PAGE_SETTINGS, currentPage: state.currentPage - 1 });
    utilScrollUp();
  };
  const pageStart = (pageNumber) => {
    dispatch({ type: PAGE_SETTINGS, currentPage: pageNumber });
    utilScrollUp();
  };
  const pageEnd = (pageNumber) => {
    dispatch({ type: PAGE_SETTINGS, currentPage: pageNumber });
    utilScrollUp();
  };
  pagination = (
    <Pagination
      postPerPage={state.postPerPage}
      totalData={state.menu_ideas !== undefined ? state.menu_ideas.length : []}
      currentPage={state.currentPage}
      paginate={paginate}
      paginateNext={paginateNext}
      paginatePrev={paginatePrev}
      pageStart={pageStart}
      pageEnd={pageEnd}
    />
  );

  const localProducts = currentData.map((item, index) => {
    return (
      <li
        key={`${item.id}${index}`}
        onClick={() => gotoDetailMenuIdea(item.slug, item.title)}
      >
        <div
          className={classes.CardRight_bgImage}
          style={{ backgroundImage: `url(${item.thumbnail_image})` }}
        />
        <h4>{item.title}</h4>
      </li>
    );
  });

  return (
    <>
      <Helmet>
        <meta
          name="description"
          content={
            "JAPFA FOOD: Discover recipes, cooks, and how-tos based on the food you love for the next new special dish on your restaurant / cafe / hotel."
          }
        />
        <meta
          name="keywords"
          content={
            "Menu ideas, food service, frozen food, supplier frozen food, Best Chicken, Tokusen, Omayo, food catering, food service delivery, Japfa Indonesia, meat shop, Chicken shop, food solutions, JBFS, Food Supplier"
          }
        />
        <meta name="author" content="" />
        <meta
          property="og:title"
          content={
            "Menu Ideas Japfa Food | Indonesia | Food Supplier"
          }
        />
        <meta
          property="og:description"
          content={
            "JAPFA FOOD: Discover recipes, cooks, and how-tos based on the food you love for the next new special dish on your restaurant / cafe / hotel."
          }
        />
        <title>
          {localStorage.getItem("selected_page_title") &&
            `${localStorage.getItem(
              "selected_page_title"
            )}${" Japfa Food | Indonesia | Food Supplier"}`}
        </title>

        <link
          rel="canonical"
          href={window.location.origin.toString() + props.location.pathname}
        />
      </Helmet>

      {/*Bread crumbs region*/}
      <section
        className={[classes.About_sections, classes.Even_section].join(" ")}
      >
        <div className={["jbfs-wrapper", classes.About_wrapper].join(" ")}>
          {/*Breadcrum region*/}
          <div className={["jbfs-breadcrumb-row"].join(" ")}>
            <HomeBreadcrumb />
            <span>/</span>
            <div>
              <FormattedMessage
                id={"menuideas.title"}
                defaultMessage={"Menu Ideas"}
              />
            </div>
          </div>
          {/*Breadcrum region*/}
        </div>
      </section>

      {/*Title region*/}
      <section
        className={[
          classes.About_sections,
          classes.Even_section,
          classes.HeaderSection_background,
        ].join(" ")}
      >
        <div
          className={[
            "jbfs-wrapper",
            classes.About_wrapper,
            classes.Header_wrapper,
          ].join(" ")}
        >
          <div className={classes.Header_title}>
            <MenuIdeasTitle
              title={
                <FormattedMessage
                  id={"menuideas.topthree"}
                  defaultMessage={"Menu Ideas of The Months"}
                />
              }
            />
          </div>
          <div className={classes.Header_card}>
            {state.latest_menu_ideas &&
              state.latest_menu_ideas.map((data, index) => (
                <MenuIdeaComponent key={`${data.id}${index}`} data={data} />
              ))}
          </div>
        </div>
      </section>

      <div
        className={["violet", classes.MenuIdeas_container].join(" ")}
        ref={(section) => {
          scrollToComponent.Violet = section;
        }}
      >
        <section className={[classes.About_sections].join(" ")}>
          <div
            className={[
              "jbfs-wrapper",
              classes.About_wrapper,
              classes.Why_wrapper,
            ].join(" ")}
          >
            <h1 className={"jbfs-title-case"}>
              <FormattedMessage
                id={"menuideas.title"}
                defaultMessage={"Menu Ideas"}
              />
            </h1>
            <div
              className={["jbfs-description", classes.Why_description].join(
                " "
              )}
            >
              {/*<HTMLEllipsis*/}
              {/*    unsafeHTML={'Find and share cooking inspiration with Japfa Best Ingredients on JBFS Menu Ideas. Discover recipes, cooks, and how-tos based on the food you love for the next new special dish on your restaurant/ cafe/ hotel.'}*/}
              {/*    maxLine='5'*/}
              {/*    ellipsis='...'*/}
              {/*    basedOn='letters'/>*/}
              <p>
                <FormattedMessage
                  id={"menuideas.description"}
                  defaultMessage={
                    "Find and share cooking inspiration with Japfa Ingredients on Japfa Food Menu Ideas. Discover recipes, cooks, and how-tos based on the food you love for the next new special dish on your restaurant/ cafe/ hotel."
                  }
                />
              </p>
            </div>

            <div className={classes.MenuIdeas_row}>
              <section className={classes.Filter_wrapper}>
                <div>
                  <div className={classes.MdbNavItem_searchContainer}>
                    <i
                      onClick={doSearchProductsButton}
                      className={["fa fa-search", classes.NavSearchIcon].join(
                        " "
                      )}
                    />
                    {/*<input placeholder={"Search Menu Ideas"}*/}
                    {/*       className={[classes.MdbNavItem_searchInput].join(' ')}*/}
                    {/*       type="text"*/}
                    {/*       onChange={(event) => onChangeKeywordHandler(event)}*/}
                    {/*       onFocus={(event) => onFocusHandler(event)}*/}
                    {/*       onBlur={() => dispatch({type: IS_ERROR, payload: false})}*/}
                    {/*       onKeyPress={(event) => onEnterKeyHandler(event)}*/}
                    {/*/>*/}
                    <FormattedMessage
                      id={"menuideas.search"}
                      defaultMessage={"Search Menu Ideas"}
                    >
                      {(msg) => (
                        <input
                          placeholder={msg}
                          className={[classes.MdbNavItem_searchInput].join(" ")}
                          type="text"
                          onChange={(event) => onChangeKeywordHandler(event)}
                          onFocus={(event) => onFocusHandler(event)}
                          onBlur={() =>
                            dispatch({ type: IS_ERROR, payload: false })
                          }
                          onKeyPress={(event) => onEnterKeyHandler(event)}
                          value={state.keywords}
                        />
                      )}
                    </FormattedMessage>
                  </div>
                  {state.hasError && (
                    <div
                      className={[
                        "jbfs-search-validation",
                        classes.MdbNavItem_searchInput_error,
                      ].join(" ")}
                    >
                      <FormattedMessage
                        id={"global.header.search.notification"}
                        defaultMessage={"Please input minimum 3 characters !"}
                      />
                    </div>
                  )}
                </div>

                <div className={classes.lineGap} />
                <div className={classes.FilterMain_row}>
                  <h4>
                    <FormattedMessage
                      id={"menuideas.filter"}
                      defaultMessage={"Product Category"}
                    />
                  </h4>
                  <ul>
                    {state.isLoading === false &&
                    state.product_categories.length > 0 ? (
                      otherProductCategory
                    ) : (
                      <LoadingSimple />
                    )}
                  </ul>
                </div>
                <div className={classes.lineGap} />
              </section>

              <section>
                <div className={classes.CountSorting_container}>
                  <CountSortingContainer
                    data={state.menu_ideas}
                    label={
                      <FormattedMessage
                        id={"global.items.title"}
                        defaultMessage={"items"}
                      />
                    }
                    options={options}
                    onSortHandler={onSortHandler}
                    defaultOps={state.defaultOps}
                  />
                </div>
                {state.menu_ideas && state.menu_ideas.length < 1 ? (
                  <h4>Load data...</h4>
                ) : state.menu_ideas[0].id === null ? (
                  <h2>
                    <FormattedMessage
                      id={"global.nodatafound"}
                      defaultMessage={"No data found"}
                    />
                  </h2>
                ) : (
                  <ul className={classes.ProductsCard_grid_container}>
                    {localProducts}
                  </ul>
                )}
              </section>
            </div>

            <div className={["jbfs-paging-container"].join(" ")}>
              {pagination}
            </div>
          </div>
        </section>

        <div className={["jbfs-arrow-top"].join(" ")}>
          <JIcon
            icontype={"link_to_top"}
            onClick={() =>
              scrollToComponent(scrollToComponent.Violet, {
                offset: -99,
                align: "top",
                duration: 1500,
              })
            }
          />
        </div>
      </div>
    </>
  );
};

export default MenuIdeasPageHook;
